<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m16.5 2.82495c-1.74 0-3.41.81-4.5 2.09-1.09-1.28-2.76-2.09-4.5-2.09-3.08 0-5.5 2.42-5.5 5.5 0 3.78005 3.4 6.86005 8.55 11.54005l1.45 1.31 1.45-1.32c5.15-4.67 8.55-7.75 8.55-11.53005 0-3.08-2.42-5.5-5.5-5.5zm-4.4 15.55005-.1.1-.1-.1c-4.76-4.31-7.9-7.16-7.9-10.05005 0-2 1.5-3.5 3.5-3.5 1.54 0 3.04.99 3.57 2.36h1.87c.52-1.37 2.02-2.36 3.56-2.36 2 0 3.5 1.5 3.5 3.5 0 2.89005-3.14 5.74005-7.9 10.05005z"
    />
  </svg>
</template>
